import styled from "styled-components";

import { Form, Select as AntSelect } from "antd";

export const Group = styled.div`
  margin-bottom: 8px;
`;
export const GroupLabel = styled.p`
  color: #1070b6;
  font-size: 18px;
  font-weight: bold;
`;

export const Content = styled.div``;

export const Container = styled.div``;

export const Item = styled(Form.Item)`
  width: 100%;
  .ant-form-item-label label {
    color: #707070;
  }
`;

export const Select = styled(AntSelect)`
  width: 100%;
  height: 40px;
  font-size: 16px;
  div.ant-select-selector {
    height: 40px !important;
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      line-height: 40px;
      .ant-select-selection-item-content {
        line-height: 22px;
      }
      .ant-select-selection-item-remove {
        line-height: 22px;
      }
    }
  }
`;
